<template>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        class="dialog-container"
        center
        width="800px">
        <div slot="title" class="title">
            预警审核
        </div>
        <div class="form-content padding-lr" v-loading="loading">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="ruleForm" label-width="130px">
                <el-form-item label="教培机构名称" prop="org_id">
                    <el-select v-model="ruleForm.org_id" disabled
                               class="inp" filterable placeholder="请选择">
                        <el-option v-for="item in orgList" :key="item.id"
                                   :label="item.org_name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预警状态"
                              prop="level">
                    <el-select v-model="ruleForm.level" class="inp" placeholder="请选择"  disabled>
                        <el-option v-for="item in riskLevelOptions"
                                   :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预警提示"
                              prop="info">
                    <el-input v-model="ruleForm.info"
                              class="inp"
                              placeholder="请输入"  disabled></el-input>
                </el-form-item>
                <el-form-item label="预警描述"
                              prop="information">
                    <el-input v-model="ruleForm.information"
                              :autosize="{ minRows: 5, maxRows: 5 }"
                              class="inp"
                              placeholder="请输入"
                              resize="none"
                              type="textarea"  disabled></el-input>
                </el-form-item>
                <!--                <el-form-item label="预警时间"-->
                <!--                              prop="zhenggai_time">-->
                <!--                    <el-date-picker-->
                <!--                        v-model="ruleForm.zhenggai_time"-->
                <!--                        placeholder="选择日期"-->
                <!--                        style="width: 100%;"-->
                <!--                        type="date"-->
                <!--                        value-format="yyyy-MM-dd">-->
                <!--                    </el-date-picker>-->
                <!--                </el-form-item>-->
                <el-form-item label="处理状态"
                              prop="status">
                    <el-select v-model="ruleForm.status" class="inp" placeholder="请选择"  disabled>
                        <el-option v-for="item in riskStatusOptions2"
                                   :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item ref="chengnuoshu" class="" label="承诺书"
                              prop="chengnuoshu" v-if="ruleForm.chengnuoshu">
                    <div class="flex justify-start align-center">
                        <a v-if="ruleForm.chengnuoshu"
                           :href="ruleForm.chengnuoshu"
                           class="look" target="_blank">下载承诺书</a>
                    </div>
                </el-form-item>
                <el-form-item ref="cailiao" class="" label="证明文件"
                              prop="cailiao">
                    <div class="flex justify-start align-center">
                        <a v-if="ruleForm.cailiao"
                           :href="ruleForm.cailiao"
                           class="look" target="_blank">下载证明文件</a>
                    </div>
                </el-form-item>
            </el-form>
            <div class="btn-box">
                <div class="btn" @click="submitForm('ruleForm',1)">解除预警风险</div>
                <div class="btn cancel" @click="submitForm('ruleForm',2)">确认预警风险</div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import {scrollIntoView} from "@/utils/utils";
import {getWarningDetail, org_lst, shenheWarning} from "@/api/admin";
import {riskLevelOptions, riskStatusOptions2} from "@/utils/const";

export default {
    name: "applyRiskDialog",
    data() {
        return {
            orgList:[],
            riskLevelOptions:riskLevelOptions,
            riskStatusOptions2:riskStatusOptions2,
            ruleForm: {
                org_id: '',
                level: '',//0灰色1黄色2橘色3红色
                info: '',//预警提示（
                information: '',//预警描述
                status: '',//处理状态
                chengnuoshu: '',
                cailiao: '',//证明文件
            },
            rules: {
                org_id: [
                    {required: true, message: '请选择机构', trigger: 'blur'}
                ],
                level: [
                    {required: true, message: '请选择预警状态', trigger: 'blur'}
                ],
                info: [
                    {required: true, message: '请输入预警提示', trigger: 'blur'}
                ],
                information: [
                    {required: true, message: '请输入预警描述', trigger: 'blur'}
                ],
                status: [
                    {required: true, message: '请选择处理状态', trigger: 'blur'}
                ],
                cailiao: [
                    {required: true, message: '请上传文件', trigger: 'blur'}
                ],
            },
            loading:false
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        id: {
            type: [String, Number],
            default: ''
        },
    },
    components: {},
    created() {

    },
    methods: {
        async init() {
            this.loading = true
            let _data = await org_lst(
                '',
                '',
                '',
                '',
                '',
                1,
                10000
            )
            this.orgList = _data.data.data
            _data = await getWarningDetail(this.id)
            this.ruleForm.org_id = _data.data.org_id
            this.ruleForm.level = _data.data.level
            this.ruleForm.info = _data.data.info
            this.ruleForm.information = _data.data.instruction
            this.ruleForm.status = _data.data.status
            this.ruleForm.cailiao = _data.data.cailiao
            this.ruleForm.chengnuoshu = _data.data.chengnuoshu
            this.loading = false
        },
        submitForm(formName,type) {
            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    this.submitInfo(type)
                } else {
                    scrollIntoView(this, validates)
                }
            });
        },

        async submitInfo(type) {
            let _data = await shenheWarning(
                this.id,
                type
            );
            if (_data.status == 200) {
                this.$message.success(_data.msg);
                this.$emit('handleClose', true)
            } else {
                this.$message.error(_data.msg);
            }
        },
        handleClose() {
            this.$emit('handleClose', false)
        },
    },
    watch: {
        dialogVisible() {
            if (this.dialogVisible) {
                if (this.id) {
                    this.init()
                }
            }
        }
    },
    filters: {}
}
</script>

<style lang="scss" scoped>
.title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
}

.form-content {
    width: 100%;

    .title-flex {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 20px;

        b {
            font-size: 18px;
            color: #000000;
            font-weight: bold;
            margin-right: 10px;
        }
    }


    .width {
        width: 400px;
    }

    .btn-box {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 30px 0;

        .btn {
            width: 180px;
            height: 40px;
            background-image: linear-gradient(0deg,
                #2791ff 0%,
                #81b6ff 100%);
            border-radius: 20px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            letter-spacing: 1px;
            color: #ffffff;
            cursor: pointer;
            &.cancel{
                width: 180px;
                height: 40px;
                background: #f0f2f6;
                border-radius: 20px;
                border: solid 1px #c1c3c7;
                color: #9da0a7;
                margin-left: 20px;
            }
        }
    }

    .add {
        width: 24px;
        cursor: pointer;
    }


    .inp {
        width: 100%;
    }

    .tips {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        background-color: #fef0ef;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
        color: #f34336;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 16px;

        i {
            font-size: 20px;
            color: #f34336;
            margin-right: 4px;
        }

        &.width {
            width: 160px;
        }
    }

    .look {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        border: 1px solid #2791ff;
        color: #2791ff;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        margin-left: 10px;
        border-radius: 4px;

    }

    .mt15 {
        margin-top: 15px;
    }

    .btnUp {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        margin-left: 10px;
        background-image: linear-gradient(90deg,
            #2791ff 0%,
            #81b6ff 100%);
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #ffffff;

        i {
            font-size: 20px;
            color: #ffffff;
            margin-right: 5px;
            font-weight: 100;
        }
    }
}

.title-box {
    width: 100%;
    height: 60px;
    border-bottom: solid 2px #e3e7f0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tit-left {
        display: flex;
        justify-content: flex-start;
        padding-top: 25px;

        img {

        }

        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 5px;
        }
    }
}
</style>


